import React, { useEffect, useState} from "react";
import { Link } from 'react-router-dom';
import './projecten.css';
import ProjectenGrid from "../componenten/projectenGrid/projectenGrid";
import ProjectHeader from './componenten/ProjectHeader.jpg';

function Projecten() {
    return (
        <>
            <div className="projectpage">
                <div className="P-heading">
                    <img src={ProjectHeader} alt='Project Header' className='projectheader' />
                    <div className='overlayproject'>
                        <h1>Onze projecten</h1>
                    </div>
                </div>
                <div className='onzeprojecten'>
                    <div className="grid-projecten">
                        <ProjectenGrid enkelerij={false} animate={false} lightmode={false}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Projecten;